import { SvgIconComponent } from '@mui/icons-material';
import Circle from '@mui/icons-material/Circle';
import Contrast from '@mui/icons-material/Contrast';
import RadioButtonUnchecked from '@mui/icons-material/RadioButtonUnchecked';
import { StepStatus } from './stepStatus';

// Each status has its own shape as well as its own colour, so the three stay apart without colour vision. The step on
// screen is the exception, as Figma draws it: its selected tab says which step it is, not its status.
const GLYPHS: Record<StepStatus, { Icon: SvgIconComponent; color: string }> = {
  complete: { Icon: Circle, color: 'success.main' },
  in_progress: { Icon: Contrast, color: 'warning.main' },
  not_started: { Icon: RadioButtonUnchecked, color: 'text.disabled' }
};

interface StepStatusGlyphProps {
  status: StepStatus;
  // The step on screen: a solid blue dot, whatever its status.
  current?: boolean;
}

// Decorative: the tab that shows it carries the status name.
export const StepStatusGlyph = ({ status, current = false }: StepStatusGlyphProps) => {
  const { Icon, color } = current ? { Icon: Circle, color: 'primary.main' } : GLYPHS[status];
  return <Icon sx={{ fontSize: 12, color }} />;
};
